<template lang="html">
  <div class="live" ref="refining">
    <!-- <h3>直播</h3> -->
    <Tags v-model="tagId"/>
    <div class="panel-box" v-if="list.length" :style="{'padding-bottom': isAndroid ? '30px' : '100px' }">
      <RefiningItem v-for="item of list" :key="item.id" v-bind="item"/>
    </div>
    <transition name="bounce">
        <div v-show="loading" class="loading">加载过程中</div>
    </transition>
  </div>
</template>

<script>
import { get } from '../../../utils/request'
import { safeHeight } from '../../../utils/config'
import { isAndroid } from '../../../utils/utils'
import { createNamespacedHelpers } from 'vuex'
import Tags from './Tags'
import RefiningItem from '../../../components/RefiningItem'
import { get as getUser } from '../../../utils/token'
const { mapActions } = createNamespacedHelpers('tabbar')
export default {
  components: {
    Tags,
    RefiningItem
  },
  data () {
    return {
      list: [],
      isAndroid: isAndroid(),
      safeHeight: safeHeight,
      modelSrc: '',
      loading: false,
      page: 1,
      size: 10,
      count: 0,
      tagId: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('refining')
    })
  },
  activated () {
    this.page = 1
    this.count = 0
    this.tagId = 'all'
    this.list.length = 0
    const tagId = getUser('tagId')
    if (tagId) {
      this.tagId = `${tagId}`
    }
    // this.getAllLiveList()
  },
  methods: {
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    addUpRefresh () {
      const el = this.$refs.refining
      if (!el) {
        return
      }
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, dynamic, page } = this
          if (count > dynamic.length) {
            this.page = page + 1
            el.scrollTop = el.scrollTop - 60
            // this.loading = false
            this.getAllLiveList()
          }
        }
      })
    },
    getAllLiveList () {
      this.loading = true
      let url = `/course/h5CurriculumList?page=${this.page}&size=${this.size}`
      if (!Object.is(this.tagId, 'all')) {
        url = `${url}&type=${this.tagId}`
      }
      const promise = get({
        url
      })
      promise.then(res => {
        const { data: { code, detail: { count, list } } } = res
        if (Object.is(code, 200)) {
          this.count = count
          this.list = [...this.list, ...list]
          this.loading = false
        }
      })
    },
    goLive (url) {
    }
  },
  watch: {
    tagId (val) {
      this.page = 1
      this.count = 0
      this.list.length = 0
      this.getAllLiveList()
    },
    $route () {
      // this.getAllLiveList(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.live {
  background: #fff;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  height: calc(100% - 50px);
  .panel-box {
    margin: 0 auto 0;
    width: 91.47%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
.loading {
  background: #fff;
  display: block;
  width: 100vw;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
